<div class="db-activity-log">
  <db-ai-builder-demo-banner *ngIf="demoUser"
                         [title]="'Activity Log'" [features]="features">
  </db-ai-builder-demo-banner>
  <db-activity-log-filters [clientsList]="clientsList"
                           (onFilter)="filterActivityLog($event)"
                           [ngClass]="{'disabled-with-overlay': demoUser}">
  </db-activity-log-filters>

  <db-activities-list [activities]="filteredActivities"
                      [ngClass]="{'disabled-with-overlay': demoUser}"></db-activities-list>
</div>
